export default class Rating {

  constructor (el) {
    this.el = el
    this.items = this.el.querySelectorAll('.js-progress-bar')
    this.value = parseFloat(this.el.getAttribute('data-value'))
  }

  init () {
    this.setProgress()
  }

  setProgress () {
    for (let i = 0; i < this.items.length; i++) {
      if (i + 1 <= this.value) {
        this.items[i].style.transform = `translate(0, 0)`
      } else {
        const diff = (i + 1 - this.value) * 100
        this.items[i].style.transform = `translate(-${ diff }%, 0)`
        break;
      }
    }
  }

  destroy () {}

}